import ProdModal from "@/models/Prod";
import BasicModal from "@/models/Basic";
import MemModal from "@/models/Mem";
import AdminModel from '@/models/Admin';

const GLOBAL_CLEAR = 'GLOBAL_CLEAR';
const GET_CHINA_AREA_LIST = 'GET_CHINA_AREA_LIST';
const GET_ALL_COUNTRY_LIST = 'GET_ALL_COUNTRY_LIST';
const GET_CERTIFICATE_TYPE_OPTIONS = 'GET_CERTIFICATE_TYPE_OPTIONS';
const GET_LOGISTICS_COMPANY_OPTIONS = 'GET_LOGISTICS_COMPANY_OPTIONS';
const RECORD_FOOTPRINT = 'RECORD_FOOTPRINT';
const GET_CTS_XWJ_AI_URL = 'GET_CTS_XWJ_AI_URL';
const GET_ALL_CITY_LIST = 'GET_ALL_CITY_LIST';
const GET_CTS_XWJ_AI_TRAVELTYPE = 'GET_CTS_XWJ_AI_TRAVELTYPE';
const GET_CTS_XWJ_AI_STAYTYPE = 'GET_CTS_XWJ_AI_STAYTYPE';
const GET_CHAT_HISTORY = 'GET_CHAT_HISTORY';
const GET_HISTORY_BY_CONVERSATION_ID = 'GET_HISTORY_BY_CONVERSATION_ID';
const GET_PRODUCT_RECOMMEND = 'GET_PRODUCT_RECOMMEND';
const UPDATE_MESSAGE_OPERATE = 'UPDATE_MESSAGE_OPERATE';

/**
 * 获取中国的省市区数据
 */
async function getChinaAreaList() {
  const payload = await new ProdModal().areaList('中国');
  return {
    type: GET_CHINA_AREA_LIST,
    payload
  };
}

/**
 * 获取所有国家列表
 */
async function getAllCountryList() {
  const payload = await new BasicModal().countryPagingList({ current: 1, size: 9999 });
  return {
    type: GET_ALL_COUNTRY_LIST,
    payload
  };
}

/**
 * 获取证件类型下拉选项
 */
async function getCertificateTypeOptions() {
  const payload = await new BasicModal().dicList('APP_DOCUMENT_TYPE');
  return {
    type: GET_CERTIFICATE_TYPE_OPTIONS,
    payload
  };
}

/**
 * 获取物流公司下拉选项
 */
async function getLogisticsCompanyOptions() {
  const payload = await new BasicModal().dicList('DELIVERY_LIST');
  return {
    type: GET_LOGISTICS_COMPANY_OPTIONS,
    payload
  };
}

/**
 * 记录足迹
 * @param {number} type 类型 1-进入页面 2-离开页面
 * @param {string} pathUrl 当前页面路径
 */
async function recordFootprint(params) {
  const payload = await new MemModal().recordFootprint(params);
  return {
    type: RECORD_FOOTPRINT,
    payload
  };
}

/**
 * 获取AI助手地址
 */
async function getCtsXwjAiUrl(key) {
  const payload = await new BasicModal().dicList(key);
  return {
    type: GET_CTS_XWJ_AI_URL,
    payload
  };
}

/**
 * 获取所有城市数据
 */
async function getAllCityList() {
  const payload = await new BasicModal().getAllCityList();
  return {
    type: GET_ALL_CITY_LIST,
    payload
  };
}

/**
 * 获取旅行偏好选项
 */
async function getCtsXwjAiTravelType() {
  const payload = await new BasicModal().dicList('XWJ_AI_DIC_TRAVELTYPE');
  return {
    type: GET_CTS_XWJ_AI_TRAVELTYPE,
    payload
  };
}

/**
 * 获取住宿偏好选项
 */
async function getCtsXwjAiStayType() {
  const payload = await new BasicModal().dicList('XWJ_AI_DIC_STAYTYPE');
  return {
    type: GET_CTS_XWJ_AI_STAYTYPE,
    payload
  };
}

/**
 * dify聊天历史记录
 */
async function getChatHistory(params) {
  const payload = await new AdminModel().getChatHistory(params);
  return {
    type: GET_CHAT_HISTORY,
    payload
  };
}

/**
 * dify聊天详情
 */
async function getHistoryByConversationId(params) {
  const payload = await new AdminModel().getHistoryByConversationId(params);
  return {
    type: GET_HISTORY_BY_CONVERSATION_ID,
    payload
  };
}

/**
 * dify获取产品推荐
 */
async function getProductRecommend(params) {
  const payload = await new AdminModel().getProductRecommend(params);
  return {
    type: GET_PRODUCT_RECOMMEND,
    payload
  };
}

/**
 * dify消息操作
 */
async function updatemessageOperate(params) {
  const payload = await new AdminModel().updatemessageOperate(params);
  return {
    type: UPDATE_MESSAGE_OPERATE,
    payload
  };
}

const ACTION_TYPES = {
  GLOBAL_CLEAR,
  GET_CHINA_AREA_LIST,
  GET_ALL_COUNTRY_LIST,
  GET_CERTIFICATE_TYPE_OPTIONS,
  GET_LOGISTICS_COMPANY_OPTIONS,
  RECORD_FOOTPRINT,
  GET_CTS_XWJ_AI_URL,
  GET_ALL_CITY_LIST,
  GET_CTS_XWJ_AI_TRAVELTYPE,
  GET_CTS_XWJ_AI_STAYTYPE,
  GET_CHAT_HISTORY,
  GET_HISTORY_BY_CONVERSATION_ID,
  GET_PRODUCT_RECOMMEND,
  UPDATE_MESSAGE_OPERATE,
};

const ACTION = {
  getChinaAreaList,
  getAllCountryList,
  getCertificateTypeOptions,
  getLogisticsCompanyOptions,
  recordFootprint,
  getCtsXwjAiUrl,
  getAllCityList,
  getCtsXwjAiTravelType,
  getCtsXwjAiStayType,
  getChatHistory,
  getHistoryByConversationId,
  getProductRecommend,
  updatemessageOperate,
};

const Global = {
  ACTION_TYPES,
  ACTION
};

export default Global;